<template>
	<UserRegistrationLayout>
		<div class="slot-title" v-if="!passwordChangedSuccessfully">Reset your password</div>

		<v-form
			v-if="tokenValid && tokenCheck && !passwordChangedSuccessfully"
			v-model="isFormValid"
			ref="passwordResetForm"
			@submit.prevent="sendReset"
			class="user-input-box width-100"
		>
			<SignupTextField
				label="Email"
				iconName="email"
				:rules="emailRules"
				v-model="userEmail"
				type="email"
				autofocus
				single-line
				placeholder="mail@email.com"
				disabled
			>
			</SignupTextField>
			<PasswordTextField
				class="width-100"
				v-model="password"
				:password="password"
				label="Enter password"
				@password-valid-update="onPasswordValidationUpdate"
			/>
			<SignupTextField
				type="password"
				v-model="password2"
				iconName="input-key"
				label="Verify password"
				:rules="passwordConfirmationRule"
				placeholder="Password (at least 8 characters)"
			/>

			<AnemicButton :loading="submittingForm" :disabled="password !== password2 || !isPasswordValid" class="send-button" type="submit">
				Send
			</AnemicButton>
		</v-form>
		<div v-if="passwordChangedSuccessfully || (!tokenValid && tokenCheck)">
			<div class="slot-title">Password has changed, Please login to your account</div>
			<div class="bottom-section mt-2">
				Click to
				<a @click="navigateTo({ name: 'Login' })" class="primary-link-style">Log in</a>
			</div>
		</div>
		<div v-if="!tokenValid && !tokenCheck">
			<div class="right-side-description">Loading...</div>
		</div>
	</UserRegistrationLayout>
</template>

<script>
import { mapActions } from 'vuex';

import UserRegistrationLayout from './userRegistration/UserRegistrationLayout';
import SignupTextField from './userRegistration/components/SignupTextField';
import PasswordTextField from './userRegistration/components/PasswordTextField';

import UserRegistrationService from './userRegistration/helpers/UserRegistrationService';
import UserRegistrationMixin from './userRegistration/helpers/UserRegistrationMixin';

export default {
	name: 'ForgotPassword',
	components: {
		SignupTextField,
		PasswordTextField,
		UserRegistrationLayout,
	},
	props: {
		userID: { type: Number },
		token: { type: String },
	},
	mixins: [UserRegistrationMixin],
	data: () => ({
		userEmail: '',
		isFormValid: false,
		submittingForm: false,
		requiredRules: UserRegistrationService.getRequiredRules(),
		emailRules: UserRegistrationService.getEmailValidationRules(),
		passwordRules: UserRegistrationService.getPasswordValidationRules(),
		isPasswordValid: false,
		password: '',
		password2: '',
		tokenValid: false,
		tokenCheck: false,
		passwordChangedSuccessfully: false,
	}),
	computed: {
		passwordConfirmationRule() {
			return [() => this.password === this.password2 || 'Password must match'];
		},
	},
	methods: {
		...mapActions(['resetPassword', 'validateReset']),
		onPasswordValidationUpdate(newVal) {
			this.isPasswordValid = newVal;
		},
		async sendReset() {
			this.$refs.passwordResetForm.validate();
			if (this.isFormValid) {
				this.submittingForm = true;
				const ret = await this.resetPassword({
					userID: this.userID,
					token: this.token,
					newPassword: this.password,
					newPasswordConfirmation: this.password2,
				});
				this.submittingForm = false;
				if (ret.success) {
					this.passwordChangedSuccessfully = true;
				}
			}
		},
		async validateToken() {
			if (this.userID && this.token) {
				const ret = await this.validateReset({ userID: this.userID, token: this.token });
				if (ret.success) {
					this.tokenValid = true;
					this.userEmail = ret.email;
				}
			}
			this.tokenCheck = true;
		},
	},
	mounted() {
		this.validateToken();
	},
};
</script>

<style scoped lang="scss">
.send-button {
	height: 45px;
	width: 300px;
	padding: 0px;
	font-size: 14px !important;
	color: var(--bg-color) !important;
	background: var(--bold-border-color) !important;
}
</style>
